import { render, staticRenderFns } from "./MultipleRegression.vue?vue&type=template&id=6b54f2fc&scoped=true"
import script from "./MultipleRegression.vue?vue&type=script&lang=js"
export * from "./MultipleRegression.vue?vue&type=script&lang=js"
import style0 from "./MultipleRegression.vue?vue&type=style&index=0&id=6b54f2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54f2fc",
  null
  
)

export default component.exports